import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

// component
import Goals from './Goals';

// actions
import {addGoal, removeGoal} from 'undergraduate-student/actions/education-onboarding';

const mapStateToProps = ({goals}) => ({goals});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addGoal,
      removeGoal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Goals);
